import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Courses from './pages/Courses';
import CourseDetail from './pages/CourseDetail';
import MyCourses from './pages/MyCourses';
import About from './pages/About';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Refund from './pages/Refund';
import Profile from './pages/Profile';
import AccountSettings from './pages/AccountSettings';
import AdminDashboard from './pages/AdminDashboard';
import ManageUsers from './pages/ManageUsers';
import ManageCourses from './pages/admin/ManageCourses';
import ManageMCQs from './pages/admin/ManageMCQs';
import ManageQuestions from './pages/admin/ManageQuestions';
import MCQTest from './pages/MCQTest';
import MCQScorecard from './pages/MCQScorecard';
import AdminRoute from './components/AdminRoute';
import ScrollToTop from './components/ScrollToTop';
import SessionExpiredModal from './components/SessionExpiredModal';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AuthProvider>
        <SessionExpiredModal />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/course/:id" element={<CourseDetail />} />
          <Route path="/my-courses" element={<MyCourses />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/refund" element={<Refund />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/account-settings" element={<AccountSettings />} />

          {/* MCQ Routes (requires authentication) */}
          <Route path="/mcq/:mcqId" element={<MCQTest />} />
          <Route path="/mcq-results/:attemptId" element={<MCQScorecard />} />

          {/* Admin Routes (requires admin role) */}
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <AdminRoute>
                <ManageUsers />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/courses"
            element={
              <AdminRoute>
                <ManageCourses />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/courses/:courseId/mcqs"
            element={
              <AdminRoute>
                <ManageMCQs />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/mcqs/:mcqId/questions"
            element={
              <AdminRoute>
                <ManageQuestions />
              </AdminRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
